<div class="col-sm-4">
    <div class="checkbox">
        <label>
            <input
                type="checkbox"
                [(ngModel)]="tsCompany.financed"
                (change)="onFinancedChange($event)"
            >
            {{ 'session-details.student-tab.financed' | translate }}
        </label>
    </div>
</div>
<div class="col-sm-4">
    <input
        [(ngModel)]="tsCompany.financingCompany"
        [placeholder]="'session-details.student-tab.financingCompanyPlaceholder' | translate"
        class="form-control input-sm"
        name="financing-company"
        [disabled]="!tsCompany.financed"
        [required]="tsCompany.financed">
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/financing-edition/financing-edition.component.html